module Meevo.Plugins.MembershipDefinitions {
    "use strict";
    
    /**
    *  Commission section of Membership Definitions   
    */    

    export class CommissionSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Employee> { }


}